import { FC, ReactNode, MouseEvent } from "react"
import { Link } from "react-router-dom"
import { MediaContent, MediaRight } from "trunx"

import { Analytics } from "utils/analytics"
import { Box, Img, Media, Text } from "ui-kit/components-branded/index"

interface GoToCardProps {
    description: string | ReactNode
    previewImg: string
    buttonText: string | ReactNode
    buttonUrl: string
    onButtonClick?: (event: MouseEvent<HTMLAnchorElement>) => void
}

export const GoToCard: FC<GoToCardProps> = ({
    description,
    previewImg,
    buttonText,
    buttonUrl,
    onButtonClick,
}) => {
    return (
        <Box>
            <Media>
                <MediaContent>
                    <h1 className="blm-h3 mgb-4 media__header">Подберите&nbsp;психолога</h1>
                    <Text>{description}</Text>
                    <Img className="d-block mgt-3 media__userpic" src="userpics.png" width={132} />
                    <Img src={previewImg} className="is-hidden-tablet is-block mgb-3 mgh-auto" />
                    <Link
                        to={buttonUrl}
                        className="blm-button button is-primary is-responsive"
                        onClick={onButtonClick}
                    >
                        <Text isAccent>{buttonText}</Text>
                    </Link>
                </MediaContent>
                <MediaRight className="client-account-go-to-card__desktop-preview is-hidden-mobile column p-0 m-0 is-half is-align-self-flex-end">
                    <Img src={previewImg} />
                </MediaRight>
            </Media>
        </Box>
    )
}

export const GoToSelectionsCard = () => {
    const handleClickButton = () => {
        Analytics.go_to_selections_from_account()
    }

    const content = {
        description: <>Выберите подходящего психолога в&nbsp;ваших подборках.</>,
        previewImg: "select-therapist-illustration-selections.svg",
        buttonText: <>Перейти в&nbsp;подборки</>,
        buttonUrl: `/my/selections`,
    }

    return <GoToCard {...content} onButtonClick={handleClickButton} />
}

export const GoToSurveyCard = () => {
    const handleClickButton = () => {
        Analytics.lk_go_to_survey()
    }

    const content = {
        description: (
            <>
                Ответьте на&nbsp;вопросы в&nbsp;анкете и&nbsp;получите варианты подходящих вам
                психологов.
            </>
        ),
        previewImg: "select-therapist-illustration-first.svg",
        buttonText: "Подобрать психолога",
        buttonUrl: `/survey/psy`,
    }

    return <GoToCard {...content} onButtonClick={handleClickButton} />
}
